import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const WishlistUpdateModalComp = dynamic(() => import('./WishlistUpdateModal').then(mod => mod.WishlistUpdateModal));

export const WishlistUpdateModalConfig = {
  emptyLabel: 'wishlistupdatemodal',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/wishlistupdatemodal`,
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const WishlistUpdateModalEditable = (props: any) => (
  <EditableComponent config={WishlistUpdateModalConfig} {...props}>
    <WishlistUpdateModalComp {...props} />
  </EditableComponent>
);
